<template>
	<div class="hello">
		<!--
		<vue-particles
        color="#333333"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="polygon"
        :particleSize="0"
        linesColor="#333333"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="particles"
      >
      </vue-particles>
			-->

		<section class="head row middle-xs center-xs start-md">
			<div class="head-img-wrapper">
				<img src="../assets/daniel.jpg" id="daniel" class="daniel">
			</div>
			<div class="col-md-6 col-xs-12 intro">
				<div>
					<h1>
						Hey there!
					</h1>
					<p>
						I'm Daniel Eke and I like to create things. Since 2012 I've developed software for iOS, Android, Web, and Desktop. I'm interested in creative coding, IoT and digital health. 
						<br><br>
						Contact me at
						<a href="mailto:hello@ekedaniel.hu">hello@ekedaniel.hu</a>
						<br><br>
						On this site, you can read about some of my projects and former jobs.
					</p>
				</div>
			</div>
		</section>

		<section class="pulmoment row middle-xs">
			<div class="sliderWrapper col-md-6 col-xs-12">
				<slider animation="fade" :control-btn="false" :indicators="false" height="320px">
					<slider-item>
						<grain-img :image="pulmomentImages[0]"></grain-img>
					</slider-item>
					<slider-item>
						<grain-img :image="pulmomentImages[1]"></grain-img>
					</slider-item>
					<slider-item>
						<grain-img :image="pulmomentImages[2]"></grain-img>
					</slider-item>
				</slider>
			</div>
			<div class="col-md-6 col-xs-12">
				<h2>Pulmoment</h2>
				<p>
					Pulmoment is a software package designed to help asthma patients and doctors, by making symptom tracking easy and effective. It is my biggest personal project so far. I've developed the product with the help of students of ELTE University and with Dr. András Szánthó who is my doctor and also a co-founder of the project. Our service is used by hundreds of patients and we got very positive feedback from medical professionals too.
					<br><br>
					<center>
						<link-button text="Read more about Pulmoment" link="https://pulmoment.com"></link-button>
					</center>
				</p>
			</div>
		</section>
		<!--
		<section class="Aidminder row middle-xs">
			<div class="col-md-6 col-xs-12">
				<h2>Aidminder</h2>
				<p>
					Aidminder is a customizable and universal medication reminder device. The product development and the project was managed by me, with a industrial designer team from BME and with the supervision of my professors at the EIT Digital Master School.
					With our team, we designed and developed a device which is easy to 3D print, can be reproduced with a wide range of materials and compatible with unique medications. 

					Pulmoment is a software package designed to help asthma patients and doctors, by making symptom tracking easy and effective. It is my largest personal project so far. I've developed the product with the help of students of ELTE University and with Dr. András Szánthó who is my doctor and also a co-founder of the project. Our service is used by hundreds of patients and we got very positive feedback from medical professionals too.
					<br><br>
					<center>
						<link-button text="Read more about Pulmoment" link="https://pulmoment.com"></link-button>
					</center>
				</p>
			</div>
			<div class="sliderWrapper col-md-6 col-xs-12">
				<slider animation="fade" :control-btn="false" :indicators="false" height="320px">
					<slider-item>
						<grain-img :image="pulmomentImages[0]"></grain-img>
					</slider-item>
					<slider-item>
						<grain-img :image="pulmomentImages[1]"></grain-img>
					</slider-item>
					<slider-item>
						<grain-img :image="pulmomentImages[2]"></grain-img>
					</slider-item>
				</slider>
			</div>
		</section>
		-->

		<section class="headprocesscreative row">
			<div class="handstract col-md-6 bottom-xs row">
				<h2>Handstract</h2>
				<div>
					<p>
						Handstract is my first independent mobile application made for iOS devices. It's a unique drawing application which uses all of the available multitouch points on iPhones and iPads as vertices of polygons. It has been on the top 100 list of the Photo and Video category several times and downloaded by thousands of users. Recently Apple featured it in the daily App Store stories for the Chinese and Russian region. Below you can see some recent creations made with it. 
						<br><br>
						<center>
							<link-button text="Read more about Handstract" link="http://handstract.com"></link-button>
						</center>
					</p>
				</div>

				<div class="feed row">
					<span v-for="image of handstractFeed" class="feedElement col-xs-3"><img :src="image"></span>
				</div>
			</div>
			<div class="centroid col-md-6 bottom-xs row">
				<h2>Centroid</h2>
				<div>
					<p>
						Centroid is also a creative application for iOS devices. It uses OpenGL to create low-polygon pixelated images from the camera's feed in real-time. Users can select different shapes and resolutions to create interesting photos and wallpapers. It's even more popular than Handstract and been downloaded almost twice as much. Check out some examples below.
						<br><br>
						<center>
							<link-button text="Read more about Centroid" link="http://centroidapp.com"></link-button>
						</center>
					</p>
				</div>

				<div class="feed row">
					<span v-for="image of centroidFeed" class="feedElement col-xs-3"><img :src="image"></span>
				</div>
			</div>
		</section>

		<!--
		<section class="academy row middle-xs">
			<div class="col-md-6 col-xs-12">
				<grain-img :image="educational"></grain-img>
			</div>
			<div class="text col-md-6 col-xs-12">
				<h2>Academic projects</h2>
				<p>
					I did my BSc in Computer Science at the Faculty of Informatics of ELTE. During my studies, I've participated in educational informatics projects, most of the time voluntarily. I've also done some graphic design work for the student union and for the university itself, which helped them to shape the identity of the institute. Here are some of my activities:
					<ul>
						<li>Maintenance and development of the university’s OpenSim server.</li>
						<li>Provided IT support during interactive learning activities for children between the age 8 and 16. These events included works with Lego MindStorms products, Scratch programming, OpenSim, and Processing development.</li>
						<li>Thesis work: Gamification Framework for Educational Softwares.</li>
						<li>Award-winning ideas for the redesign of the official website of ELTE.</li>
						<li>Front-end sitebuild for the Faculty of Informatics Students Union.</li>
					</ul>
				</p>
			</div>
		</section>
		-->

		<section class="freelancing">
			<div class="row">
				<div class="text col-md-6">
					<h2>Freelancing</h2>
					<div>
						<p>
							During the years I've participated in multiple startups as a part-time software developer and graphic designer. Here's some of my larger co-operation, with some highlights:
							<ul>
								<li><b>Popit</b> - Sofware architecture design and development of a cross-platform SDK for a medical device.</li>
								<li><b>AppleRider</b> - (Formerly UsedApple) Designed and developed the website with Joomla framework. Designed online and offline marketing materials.</li>
								<li><b>Commsignia</b> - Designed early-stage marketing materials and developed their website with Wordpress.</li>
								<li><b>Endticket</b> - Developed ticket entry mobile application for iOS and Android. Implemented music recognition algorithm in C/C++ with a co-operation of a researcher from ELTE.</li>
								<li><b>EIT Digital</b> - Integrated D-Touch visual code recognition algorithm with OpenCV for iOS applications. (As a part of a university project)</li>
								<li><b>Conflive</b> - Developed multiple mobile applications for conferences for iOS and Android devices.</li>
							</ul>
						</p>
					</div>
				</div>
				<div class="logos col-md-6 col-xs-12 row center-xs middle-xs">
					<div class="col-md-4">
						<img src="../assets/logos/logo_popit.png" height="80">
					</div>
					<div class="col-md-4">
						<img src="../assets/logos/logo_applerider.png" height="80">
					</div>
					<div class="col-md-4">
						<img src="../assets/logos/logo_endticket.png" height="80">
					</div>
					<div class="col-md-4">
						<img src="../assets/logos/logo_commsignia.png" height="80">
					</div>
					<div class="col-md-4">
						<img src="../assets/logos/logo_eitdigital.png" height="80">
					</div>
					<div class="col-md-4">
						<img src="../assets/logos/logo_conflive.png" height="80">
					</div>
				</div>
			</div>
		</section>

		<section class="awards">
			<h2>Awards</h2>
			<div class="row">
				<div v-for="award in awards" class="award col-xs-12 col-md-3">
					<p>
						<span class="cup">🏆</span><br>
						<span class="year">{{award.year}}</span><br>
						<span class="name">{{award.name}}</span><br>
						{{award.desc}}
					</p>
				</div>
			</div>
		</section>

		<section class="led row middle-xs">
			<div class="col-md-6 col-xs-12">
				<img src="../assets/led.gif">
			</div>
			<div class="col-md-6 col-xs-12">
				<h2>Screen to LED</h2>
				<p>
					In 2017 I've made an open source application for macOS in Objective-C which uses an Arduino and a LED strip to project the dominant colors of the screen behind the display. It's certainly not my most complex project but looks very cool nonetheless.
					<br><br>
					<center>
						<link-button text="View project on GitHub" link="https://github.com/Endanke/ScreenLED"></link-button>
					</center>
				</p>
			</div>
		</section>

		<section class="paintings row middle-xs">
			<div class="col-md-6 col-xs-12">
				<h2>Abstract paintings</h2>
				<p>
					In my free time, I like to paint abstract expressionist images. I usually don't focus on figurative themes, since I found the creation of ad-hoc graphical elements more relaxing.
					<br><br>
					<center>
						<link-button text="View my portfolio" link="https://headprocess.tumblr.com"></link-button>
					</center>
				</p>
			</div>
			<div class="col-md-6 col-xs-12">
				<img src="../assets/painting.jpg">
			</div>
		</section>

		<section class="finish center-xs">
			<h2>Thanks for checking out my site!</h2>
			<p>
				Contact me at:
				<br><a href="mailto:hello@ekedaniel.hu">hello@ekedaniel.hu</a>
				<br>On social media: 
				<br>
				<a href="https://twitter.com/endanke" target="_blank">
					<font-awesome-icon :icon="['fab', 'twitter']" size="2x"/>
				</a>
				<a href="https://instagram.com/headprocess" target="_blank">
					<font-awesome-icon :icon="['fab', 'instagram']" size="2x"/>
				</a>
				<a href="https://www.linkedin.com/in/endanke/" target="_blank">
					<font-awesome-icon :icon="['fab', 'linkedin']" size="2x"/>
				</a>
			</p>
		</section>

	</div>
</template>

<script>
	import _ from 'lodash'
	import Button from './Button'
	import GrainImg from './GrainImg'
	import { Slider, SliderItem } from 'vue-easy-slider'
	import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
	import fontawesome from '@fortawesome/fontawesome'
	import brands from '@fortawesome/fontawesome-free-brands'

	fontawesome.library.add(brands)

	var prevData = undefined;
	var iteration = 0;
	var feedHighlightIndex = 0;

	export default {
		name: 'Home',
		components: {
			'link-button': Button,
			GrainImg,
			Slider,
			SliderItem,
			FontAwesomeIcon
		},
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				instaFeed: [],
				handstractFeed: [
				require("../assets/insta/h1.jpg"),
				require("../assets/insta/h2.jpg"),
				require("../assets/insta/h3.jpg"),
				require("../assets/insta/h4.jpg")
				],
				centroidFeed: [
				require("../assets/insta/c1.jpg"),
				require("../assets/insta/c2.jpg"),
				require("../assets/insta/c3.jpg"),
				require("../assets/insta/c4.jpg")
				],
				pulmomentImages: [
				require("../assets/pulmoment.jpg"),
				require("../assets/team.jpg"),
				require("../assets/presentation.jpg")
				],
				educational: require("../assets/edu.jpg"),
				awards:[
				{
					"year": "2018",
					"name": "Featured app on the App Store",
					"desc": "Apple selected Handstract in a daily story on the App Store. (China - 2018 Sept. 17., Russia - 2018 Dec. 9.)"
				},
				{
					"year": "2017",
					"name": "Startup of the Month Award",
					"desc": "Awarded to Pulmoment by The Hungarian Ministry for National Economy"
				},
				{
					"year": "2017",
					"name": "Hungarian e-Health Day - Düsseldorf 2. place",
					"desc": "Awarded to Pulmoment by the Budapest Enterprise Agency"
				},
				{
					"year": "2016",
					"name": "Winner of the Students Startup Competition of Újbuda",
					"desc": "With the Pulmoment startup idea, business plan and elevator pitch"
				},
				{
					"year": "2016",
					"name": "ELTE Innovative Student Idea Award 1. place",
					"desc": "With the Pulmoment startup concept and elevator pitch"
				},
				{
					"year": "2015",
					"name": "Mobilweekend Audience award",
					"desc": "Three-day team based startup contest"
				},
				{
					"year": "2015, 2016",
					"name": "Winner of the Beesmarter competition",
					"desc": "24-hour team based mobile programming contest, including technologies like machine learning, smart healthcare devices, and drone programming"
				},
				{
					"year": "2012",
					"name": "House of Terror Short Film Contest 3. place",
					"desc": "The competition was held during the 10 year anniversary of the House of Terror"
				}
				]
			}
		},
		mounted(){
			/*
			setInterval(function() {
				var c = document.getElementById("effect");
				var width = 320;
				var height = 320;
				c.width = width * 2;
				c.height = height * 2;
				c.style.width = width + "px";
				c.style.height = height + "px";

				var ctx = c.getContext("2d");
				ctx.scale(2,2);

				var a = rnd(0, width);
				var b = rnd(0, height);

				if(iteration > 10){
					prevData = undefined;
					iteration = 0;
				}

				if(prevData){
					var img = new Image;
					img.src = prevData;
					ctx.drawImage(img,0,0,320,320);
				}

				ctx.fillStyle = "rgba(0, 64, 255, 0.2)";
				ctx.beginPath();
				ctx.moveTo(a, b);
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(a, b);
				ctx.closePath();
				ctx.fill();

				ctx.fillStyle = "rgba(255, 64, 0, 0.2)";
				ctx.beginPath();
				ctx.moveTo(a, b);
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(a, b);
				ctx.closePath();
				ctx.fill();

				ctx.fillStyle = "rgba(0, 255, 0, 0.2)";
				ctx.beginPath();
				ctx.moveTo(a, b);
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(rnd(0, width), rnd(0, height));
				ctx.lineTo(a, b);
				ctx.closePath();
				ctx.fill();

				var dataUrl = c.toDataURL();
				var storedImage = document.createElement('img');
				storedImage.className = "col-md-2 storedImage";
				storedImage.src = dataUrl;
				prevData = dataUrl;

				// Style your image here
				storedImage.style.width = '100px';
				storedImage.style.height = '100px';

				ctx.globalCompositeOperation = 'source-atop';
				var img=document.getElementById("daniel");
				ctx.drawImage(img,0,0,320,320);
				iteration++;
			}, 1000);
			*/

			setInterval(function() {
				var feedImages = document.getElementsByClassName("feedElement");
				if(feedImages.length > 0){
					feedImages[feedHighlightIndex].classList.remove("highlighted");
					if(feedHighlightIndex < feedImages.length - 1){
						feedHighlightIndex += 1;
					}else{
						feedHighlightIndex = 0;
					}
					feedImages[feedHighlightIndex].classList.add("highlighted");
				}
			}, 1000);
		}
	}

	function rnd(a,b) {
		return Math.floor(Math.random() * b) + a;
	}
</script>

<style scoped>
	h1, h2{
		margin: 16px 0;
		padding: 16px;
	}
	a {
		font-weight: bold;
		text-decoration: none;
		color: #2686D2;
	}
	.col-xs, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
		padding: 0;
		line-height: 0;
	}
	.col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9{
		padding: 0;
	}

	p, ul{
		line-height: 1.5;
	}

	section p {
		padding: 0px 16px 16px 16px;
	}

	.row{
		margin: 0;
	}

	.project{
		background-color: #a7d0dd;
		border: 1px solid #8dafba;
	}

	.intro p{
		padding: 0 16px;
	}

	.daniel{
		max-height: 256px;
		float: right;
	}

	.particles{
		position: fixed;
		top: 0;
		z-index: -100;
		height: 100%;
		width: 100%;
	}

	.headprocesscreative {
		background-color: #b3b3b3;
	}

	.headprocesscreative .feedElement {
		padding: 0;
		line-height: 0;
	}

	.handstract{
		background-color: #1D84D5;
		color: white;
	}

	.centroid{
		background-color: #E45740;
		color: white;
	}

	.feed{
		background-color: black;
		z-index: 100;
	}

	.feedElement img{
		transition: all 0.3s;
	}

	.feedElement.highlighted img{
		transform: scale(1.2);
		box-shadow: 0 0 10px rgba(0,0,0,0.3);
	}

	.academy{
		align-items: stretch;
	}

	.academy .text{
		padding: 5% 0;
	}

	.pulmoment {
		background-color: #3392A6;
		color: white;
	}

	.pulmoment .sliderWrapper{
		padding-bottom: 25%;
		min-height: 320px;
		position: relative;
	}

	.pulmoment .slider{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		height: auto !important;
	}

	.award .cup{
		font-size: 30pt;
		opacity: 0.3;
	}

	.award .name{
		font-size: 12pt;
		font-weight: bold;
	}

	.award .year{
		font-weight: bold;
	}

	.freelancing{
		background-color: #2BFDB7;
	}

	.freelancing .text{
		padding: 5% 0;
	}

	.freelancing .logos{
		background-color: white;
	}

	.led {
		background-color: #275567;
		color: white ;
	}

	.led img{
		width: 100%;
	}

	.paintings {
		background-color: #333;
		color: white;
		overflow: hidden;
	}

	.paintings img{
		width: 100%;
	}

	img {
		max-width: 100%;
	}

	.head-img-wrapper{
		position: relative;
	}

	#effect{
		background-color: transparent;
	}

	@keyframes anim {
		from {
			transform: scale(1.0);
			box-shadow: 0 0 0 rgba(0,0,0,0.3);
		}

		to {
			transform: scale(1.5);
			box-shadow: 0 0 10px rgba(0,0,0,0.3);
		}
	}

	.squares span {
		display: block;
		animation-name: anim;
		animation-iteration-count: infinite;
		animation-direction: alternate;
	}
	.sq1{
		background-color: RGBA(30, 30, 30, 1.00);
		animation-duration: 16.1s;
		width: 100px;
		height: 50px;
	}
	.sq2{
		background-color: RGBA(59, 157, 188, 1.00);
		animation-duration: 18.2s;
		width: 100px;
		height: 100px;
	}
	.sq3{
		background-color: RGBA(231, 138, 64, 1.00);
		animation-duration: 15.3s;
		width: 30px;
		height: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue